import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CartHttpService } from './http/cart-http.service';
import { QuoteHttpService } from './http/quote-http.service';
import { AccountHttpService } from './http/account-http.service';

@Injectable({
  providedIn: 'root',
})
export class SchedulerService {
  readonly cartHttp = inject(CartHttpService);
  readonly quoteHttp = inject(QuoteHttpService);
  readonly accountHttp = inject(AccountHttpService);
  public technicians$ = new Subject<number[]>();
  public techniciansEnabled$ = new BehaviorSubject<boolean>(true);
  public showCustomEvents$ = new BehaviorSubject<boolean>(true);
  public requestEvents$ = new Subject<void>();
  public showWeekend = signal(false);

  // constructor() {
  //   effect(() => {
  //     console.log('request events again', this.showWeekend());
  //     if (this.showWeekend()) {
  //       setTimeout(() => this.requestEvents$.next(), 1);
  //     }
  //   });
  // }

  async waitingProjects(options: {
    action: string;
    customer: string | number | null;
  }) {
    return []
      .concat(await this.getCarts(options))
      .concat(await this.getWorkflows(options))
      .concat(await this.getAccounts(options));
  }

  getCarts(options) {
    return new Promise(resolve => {
      this.cartHttp.getCartsByActionFilter(options).subscribe(res => {
        resolve(
          res.map(i => {
            i['type'] = 'cart';
            return i;
          })
        );
      });
    });
  }

  getWorkflows(options) {
    return new Promise(resolve => {
      this.quoteHttp.getWorkflowsByActionFilter(options).subscribe(res => {
        resolve(
          res.map(i => {
            i['type'] = 'workflow';
            return i;
          })
        );
      });
    });
  }

  getAccounts(options) {
    return new Promise(resolve => {
      this.accountHttp.getAccountsByActionFilter(options).subscribe(res => {
        resolve(
          res.map(i => {
            i['type'] = 'account';
            return i;
          })
        );
      });
    });
  }

  processTaskOptions(list) {
    return list.reduce((acc, item) => {
      acc.push(this.processTaskOption(item));
      return acc;
    }, []);
  }

  processTaskOption(item) {
    const companyName = item.company_name?.trim() || '';
    const billingTitle = item.billing_title?.trim() || '';
    const billingName = item.billing_name?.trim() || '';

    // Build alias from available identifiers
    const aliasParts = [item.alias, item.cart, item.quote, item.id];
    const alias = aliasParts.filter(Boolean).join('-');

    // Build the billing label (e.g., "Manager John Doe")
    const billingLabel = [billingTitle, billingName].filter(Boolean).join(' ');

    // Only add parentheses if billing info exists
    const parenthesizedBilling = billingLabel ? `(${billingLabel})` : '';

    // Build the final label
    const labelParts = [alias, companyName, parenthesizedBilling].filter(
      Boolean
    );
    const label = labelParts.join(' ');

    // Return formatted data
    return {
      type: item.type,
      label,
      value: item,
    };
  }
}
